import { render, staticRenderFns } from "./UserContactPersonEdit.vue?vue&type=template&id=be4da110"
import script from "./UserContactPersonEdit.js?vue&type=script&lang=js&external"
export * from "./UserContactPersonEdit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports